import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import IconStyles from "components/icons/Icon.module.scss";

export const OnlineCourse = ({size, fill, className, id}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 48 48";
  _attributes.width = _attributes.height = size || 48;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(IconStyles["icon"], className);
  } else {
    _attributes.className = IconStyles["icon"];
  }

  return (
    <svg {..._attributes}>
      <rect className={IconStyles["icon__canvas"]} x={"0"} y={"0"} width={"48"} height={"48"}/>
      <path d="M6,24c0,-9.875 8.125,-18 18,-18c9.875,0 18,8.125 18,18c0,9.875 -8.125,18 -18,18c-9.875,0 -18,-8.125 -18,-18Zm3.007,0c0.001,8.223 6.769,14.989 14.992,14.989c8.225,0 14.992,-6.767 14.992,-14.992c0,-8.224 -6.767,-14.991 -14.991,-14.992c-0.001,0 -0.001,0 -0.002,0c-8.224,0 -14.991,6.767 -14.991,14.991c0,0.002 0,0.003 0,0.004Zm12.516,6.254c-0.302,-0.154 -0.493,-0.465 -0.492,-0.805l0,-10.863c0,0 0,0 0,0c0,-0.494 0.406,-0.9 0.9,-0.9c0.191,0 0.378,0.061 0.532,0.174l7.477,5.433c0.235,0.168 0.374,0.439 0.374,0.728c0,0.288 -0.139,0.559 -0.374,0.727l-7.474,5.429c-0.153,0.114 -0.339,0.177 -0.53,0.18c-0.143,-0.001 -0.285,-0.035 -0.413,-0.101l0,-0.002Z" fill={fill} />
    </svg>
  );
};

OnlineCourse.defaultProps = {
  size: 48,
  fill: "#fff",
  className: "",
  id: ""
};

OnlineCourse.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  fill: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
